import { Routes } from '@angular/router';
import { customerAuthGuard } from '../core/guards/customer-auth.guard';
import { customerPortalGuard } from '../core/guards/customer-portal.guard';
import { ClientLayoutComponent } from '../layout/client-layout/client-layout.component';

export const clientRoutes: Routes = [
  {
    path: 'book',
    canActivate: [customerPortalGuard],
    loadComponent: () => import('../pages/client/booking/booking.component').then(m => m.BookingComponent),
  },
  {
    path: '',
    component: ClientLayoutComponent,
    canActivate: [customerPortalGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('../pages/client/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'rooms',
        loadComponent: () => import('../pages/client/rooms/rooms.component').then(m => m.RoomsComponent),
      },
      {
        path: 'rooms/:roomId',
        loadComponent: () => import('../pages/client/room-detail/room-detail.component').then(m => m.RoomDetailComponent),
      },
      {
        path: 'about',
        loadComponent: () => import('../pages/client/about/about.component').then(m => m.AboutComponent),
      },
      {
        path: 'reviews',
        loadComponent: () => import('../pages/client/review/review.component').then(m => m.ReviewComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('../pages/client/contact/contact.component').then(m => m.ContactComponent),
      },
      {
        path: 'profile',
        canActivate: [customerAuthGuard],
        loadComponent: () => import('../pages/client/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'profile/edit',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('../pages/client/profile/edit/edit.component').then(m => m.ProfileEditComponent),
      },
      {
        path: 'notifications',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('../pages/client/notifications/notifications.component').then(m => m.NotificationsComponent),
      },
      {
        path: 'my-bookings',
        canActivate: [customerAuthGuard],
        loadComponent: () => import('../pages/client/my-bookings/my-bookings.component').then(m => m.MyBookingsComponent),
      },
      {
        path: 'my-bookings/:code',
        canActivate: [customerAuthGuard],
        loadComponent: () =>
          import('../pages/client/my-bookings/my-bookings-detail.component').then(
            m => m.MyBookingsDetailComponent,
          ),
      },
      {
        path: 'change-password',
        canActivate: [customerAuthGuard],
        loadComponent: () => import('../pages/client/change-password/change-password.component').then(m => m.ChangePasswordComponent),
      },
      {
        path: 'not-found',
        loadComponent: () => import('../pages/client/notfound/notfound.component').then(m => m.NotfoundComponent),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
];
